export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const TOGGLE_REGISTERING_USER = 'TOGGLE_REGISTERING_USER';
export interface ReceiveRegisterUserAction {
    type: typeof REGISTER_USER;
    isLogged: boolean;
}
export interface ReceiveRegisterUserWithErrorAction {
    type: typeof REGISTER_USER_ERROR;
    error: Error;
}

export interface ToggleRegisteringUserAction {
    type: typeof TOGGLE_REGISTERING_USER;
    registeringUser: boolean;
}

export type UserActionTypes =
    | ReceiveRegisterUserAction
    | ReceiveRegisterUserWithErrorAction
    | ToggleRegisteringUserAction;
